import { CheckCircle2, Target } from 'lucide-react';

export interface ObjectiveProgressValue {
  completed: number;
  in_progress: number;
  total: number;
}

export default function ObjectiveProgress({ progress }: { progress?: ObjectiveProgressValue | null }) {
  if (!progress || progress.total === 0) {
    return <span className="text-md text-muted-foreground">—</span>;
  }

  const completed = Math.min(progress.completed, progress.total);
  const percent = Math.round((completed / progress.total) * 100);
  const isComplete = completed === progress.total;

  return (
    <span
      className={`inline-flex min-w-[104px] items-center gap-2 rounded-xl px-2.5 py-1 text-xs font-semibold ${
        isComplete
          ? 'bg-green-500/10 text-green-700 dark:text-green-400'
          : 'bg-primary/10 text-primary'
      }`}
      title={`${completed} completed, ${progress.in_progress} in progress, ${progress.total} total objectives`}
    >
      {isComplete ? <CheckCircle2 className="h-3.5 w-3.5" /> : <Target className="h-3.5 w-3.5" />}
      <span className="tabular-nums">{completed} / {progress.total}</span>
      <span className="h-1.5 w-7 overflow-hidden rounded-full bg-current/15">
        <span className="block h-full rounded-full bg-current" style={{ width: `${percent}%` }} />
      </span>
    </span>
  );
}
